// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

.search-container {
  margin: 10px 0;
  max-width: 300px;
}

th {
  cursor: pointer;
  white-space: nowrap;
}

.table-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.page-size-selector {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  grid-gap: 10px;
}

.gap-2 {
  gap: 0.5rem;
}

.hyper-link {
  color: #c39a00 !important;
  cursor: pointer;
}

.success {
  color: #28d094 !important;
  cursor: pointer;
}

.disabled {
  cursor: initial;
  pointer-events: none;
  opacity: 0.5;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRhYmxlLXZpZXcuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQVc7QUFDYjs7QUFFQTtFQUNFLGNBQWM7RUFDZCxnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxlQUFlO0VBQ2YsbUJBQW1CO0FBQ3JCOztBQUVBO0VBQ0UsYUFBYTtFQUNiLG1CQUFtQjtFQUNuQiw4QkFBOEI7RUFDOUIsZUFBZTtBQUNqQjs7QUFFQTtFQUNFLGFBQWE7RUFDYixxQ0FBcUM7RUFDckMsbUJBQW1CO0VBQ25CLGNBQWM7QUFDaEI7O0FBRUE7RUFDRSxXQUFXO0FBQ2I7O0FBRUE7RUFDRSx5QkFBeUI7RUFDekIsZUFBZTtBQUNqQjs7QUFFQTtFQUNFLHlCQUF5QjtFQUN6QixlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsZUFBZTtFQUNmLG9CQUFvQjtFQUNwQixZQUFZO0FBQ2QiLCJmaWxlIjoidGFibGUtdmlldy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsidGFibGUge1xuICB3aWR0aDogMTAwJTtcbn1cblxuLnNlYXJjaC1jb250YWluZXIge1xuICBtYXJnaW46IDEwcHggMDtcbiAgbWF4LXdpZHRoOiAzMDBweDtcbn1cblxudGgge1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG59XG5cbi50YWJsZS1hY3Rpb24ge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIHBhZGRpbmc6IDAgMTBweDtcbn1cblxuLnBhZ2Utc2l6ZS1zZWxlY3RvciB7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KDIsIDFmcik7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdyaWQtZ2FwOiAxMHB4O1xufVxuXG4uZ2FwLTIge1xuICBnYXA6IDAuNXJlbTtcbn1cblxuLmh5cGVyLWxpbmsge1xuICBjb2xvcjogI2MzOWEwMCAhaW1wb3J0YW50O1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbi5zdWNjZXNzIHtcbiAgY29sb3I6ICMyOGQwOTQgIWltcG9ydGFudDtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4uZGlzYWJsZWQge1xuICBjdXJzb3I6IGluaXRpYWw7XG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICBvcGFjaXR5OiAwLjU7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/table-view/table-view.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA,wgDAAwgD","sourcesContent":["table {\n  width: 100%;\n}\n\n.search-container {\n  margin: 10px 0;\n  max-width: 300px;\n}\n\nth {\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.table-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n\n.page-size-selector {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  align-items: center;\n  grid-gap: 10px;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.hyper-link {\n  color: #c39a00 !important;\n  cursor: pointer;\n}\n\n.success {\n  color: #28d094 !important;\n  cursor: pointer;\n}\n\n.disabled {\n  cursor: initial;\n  pointer-events: none;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
